var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowRightStartOnRectangleIcon, UserIcon, } from "@heroicons/react/24/outline";
import { UserCircleIcon } from "@heroicons/react/24/solid";
import { useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { useNavigate } from "react-router-dom";
import { WPQTDropdown, WPQTDropdownItem, } from "../../../../components/Dropdown/WPQTDropdown";
import { logoutUserPageRequest } from "../../../api/user-page-api";
import { SET_USER_LOGGED_IN } from "../../../constants";
import { useErrorHandler } from "../../../hooks/useErrorHandler";
import { useSession } from "../../../hooks/useSession";
import { UserPageAppContext } from "../../../providers/UserPageAppContextProvider";
function ProfileDropdown() {
    const { state: { pageHash }, loadUserPageStatus, userPageAppDispatch, } = useContext(UserPageAppContext);
    const { handleError } = useErrorHandler();
    const { deleteSessionCookie } = useSession();
    const navigate = useNavigate();
    const logOut = () => __awaiter(this, void 0, void 0, function* () {
        try {
            yield logoutUserPageRequest(pageHash);
            yield deleteSessionCookie();
            userPageAppDispatch({ type: SET_USER_LOGGED_IN, payload: false });
            loadUserPageStatus();
        }
        catch (error) {
            handleError(error);
            loadUserPageStatus();
        }
    });
    return (_jsxs(WPQTDropdown, { anchor: "bottom end", menuBtn: ({ active }) => (_jsx("div", { children: _jsx(UserCircleIcon, { className: `wpqt-icon-blue wpqt-size-11 ${active ? "wpqt-text-blue-900" : ""} hover:wpqt-text-blue-900` }) })), children: [_jsx(WPQTDropdownItem, { text: __("View profile", "quicktasker"), icon: _jsx(UserIcon, { className: "wpqt-icon-blue wpqt-size-4" }), className: "wpqt-mb-4", onClick: () => {
                    navigate("/user/profile");
                } }), _jsx(WPQTDropdownItem, { text: __("Log out", "quicktasker"), icon: _jsx(ArrowRightStartOnRectangleIcon, { className: "wpqt-icon-red wpqt-size-4" }), className: "!wpqt-mb-0", onClick: logOut })] }));
}
export { ProfileDropdown };
